import React, {useState} from "react";
import { useDetectClickOutside } from 'react-detect-click-outside';
import { Link } from "react-router-dom";
const SubMenu = ({ item, showMenubar }) => {
  const [submenu, setSubmenu] = useState(false);
  const showSubmenu = () => setSubmenu(!submenu);
  const ClickOutside = () => {
    setSubmenu(false);
  }
  const ref = useDetectClickOutside({ onTriggered: ClickOutside });

  const handleClick = () => {
    if (item.subMenu) {
      showSubmenu();
    } else {
      showMenubar();
    }
  };

  const closeMenu = () => {
    showMenubar();
  };
  return (
    <div className={item.cName} ref={ref}>
      <Link to={item.path} onClick={handleClick}>
        <div>
          <span>
            <img src={item.icon} alt="" />
          </span>
          <span>{item.title}</span>
        </div>
        <div className="arrow">
          {item.subMenu && submenu
            ? item.iconOpened
            : item.subMenu
              ? item.iconClosed
              : null}
        </div>
      </Link>
      <div className={submenu ? "subMenu show" : "subMenu"}>
        {submenu &&
          item.subMenu.map((submenuItem, index) => {
            return (
              <Link to={submenuItem.path} key={index} onClick={closeMenu}>
                {submenuItem.title}
              </Link>
            );
          })}
      </div>
    </div>
  );
};

export default SubMenu;
